import {Address} from "../types/domain/address";

export const getFullAddress = (address: Address) =>
    `${address.address}; ${address.city}; ${address.state ? address.state + "; " : ""}${address.country}; ${address.postalCode}`;
